import {
  adaptedToLocation,
  locationToAdapted,
  locationsToAdapted,
} from "../../adapter/locationAdapter";
import { adaptedToOccupants, occupantsToAdapted } from "../../adapter/occupantAdapter";
import { HttpMethod, initFetch } from "../../utils/fetcher";
import { isExerciceCourant } from "./exerciceAction";

export const LOAD_SUCCESS_LOCATIONS = "LOAD_SUCCESS_LOCATIONS";
export const LOAD_FAIL_LOCATIONS = "LOAD_FAIL_LOCATIONS";
export const SAVE_SUCCESS_LOCATIONS = "SAVE_SUCCESS_LOCATIONS";
export const SAVE_FAIL_LOCATIONS = "SAVE_FAIL_LOCATIONS";
export const UPDATE_SUCCESS_LOCATIONS = "UPDATE_SUCCESS_LOCATIONS";
export const UPDATE_FAIL_LOCATIONS = "UPDATE_FAIL_LOCATIONS";
export const DELETE_SUCCESS_LOCATIONS = "DELETE_SUCCESS_LOCATIONS";
export const HANDLE_SUCCESS_ALL_LOCATIONS = "HANDLE_SUCCESS_ALL_LOCATIONS";
export const DELETE_FAIL_LOCATIONS = "DELETE_FAIL_LOCATIONS";
// OCCUPANTS
export const SAVE_SUCCESS_OCCUPANTS = "SAVE_SUCCESS_OCCUPANTS";
export const SAVE_FAIL_OCCUPANTS = "SAVE_FAIL_OCCUPANTS";
export const UPDATE_SUCCESS_OCCUPANTS = "UPDATE_SUCCESS_OCCUPANTS";
export const UPDATE_FAIL_OCCUPANTS = "UPDATE_FAIL_OCCUPANTS";
export const DELETE_SUCCESS_OCCUPANTS = "DELETE_SUCCESS_OCCUPANTS";
export const DELETE_FAIL_OCCUPANTS = "DELETE_FAIL_OCCUPANTS";

export function loadLocations() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      // Exercice sélectionné dans le header (année de début)
      const { annee } = getState().exercice;
      const { url, params } = initFetch(`locations?year=${annee}`, HttpMethod.GET);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.location);
          // Réponse d'un exercice abandonné entre-temps : ignorée
          if (!isExerciceCourant(getState, annee)) return;
          dispatch({
            type: LOAD_SUCCESS_LOCATIONS,
            payload: locationsToAdapted(res.location),
          });
        })
        .catch((err) => {
          reject(err);
          if (!isExerciceCourant(getState, annee)) return;
          dispatch({
            type: LOAD_FAIL_LOCATIONS,
            error: err,
          });
        });
    });
  };
}

export function saveLocation(jsonData) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`locations`, HttpMethod.POST);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToLocation(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(locationToAdapted(res.location));
          dispatch({
            type: SAVE_SUCCESS_LOCATIONS,
            payload: locationToAdapted(res.location),
          });
        })
        .catch((err) => {
          dispatch({
            type: SAVE_FAIL_LOCATIONS,
            error: err,
          });
        });
    });
  };
}

export function updateLocation(jsonData, id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`locations/${id}`, HttpMethod.PUT);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToLocation(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(locationToAdapted(res.location));
          dispatch({
            type: UPDATE_SUCCESS_LOCATIONS,
            payload: locationToAdapted(res.location),
          });
        })
        .catch((err) =>
          dispatch({
            type: UPDATE_FAIL_LOCATIONS,
            error: err,
          })
        );
    });
  };
}

export function deleteLocation(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`locations/${id}`, HttpMethod.DELETE);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.location);
          dispatch({
            type: DELETE_SUCCESS_LOCATIONS,
            payload: locationToAdapted(res.location),
            id: id,
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: DELETE_FAIL_LOCATIONS,
            error: err,
          });
        });
    });
  };
}

// OCCUPANT
export function saveOccupants(jsonData, location_id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`occupants`, HttpMethod.POST);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToOccupants(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(occupantsToAdapted(res.occupant));
          dispatch({
            type: SAVE_SUCCESS_OCCUPANTS,
            payload: occupantsToAdapted(res.occupant),
            id: location_id,
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: SAVE_FAIL_OCCUPANTS,
            error: err,
          });
        });
    });
  };
}

export function updateOccupants(jsonData, location_id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`occupants`, HttpMethod.PUT);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToOccupants(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(occupantsToAdapted(res.occupant));
          dispatch({
            type: UPDATE_SUCCESS_OCCUPANTS,
            payload: occupantsToAdapted(res.occupant),
            id: location_id,
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: UPDATE_FAIL_OCCUPANTS,
            error: err,
          });
        });
    });
  };
}
